import { render, staticRenderFns } from "./planTable.vue?vue&type=template&id=4372c17d&scoped=true&"
import script from "./planTable.vue?vue&type=script&lang=js&"
export * from "./planTable.vue?vue&type=script&lang=js&"
import style0 from "./planTable.vue?vue&type=style&index=0&id=4372c17d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372c17d",
  null
  
)

export default component.exports